import { useState, useEffect, useRef } from "react";
import { IonModal, IonContent, IonAccordionGroup, IonCard, IonGrid,IonRow,IonCol, IonLabel,IonInput,IonIcon,IonText,useIonAlert } from '@ionic/react';
import { calendarClearOutline,timeOutline } from "ionicons/icons"
import { useHistory } from "react-router-dom";
import { validateDeliveryAddressBeforeSubmit  } from "../services/handlers"


import AddressAccordion from "./addressAccordion";
import MapComponent from "./mapComponent";
import SummaryComponent from "./summaryComponent";
import BottomNavComponent from "./navigationButton";
import InputAddressComponent from "./inputAddressComponent";
import DisplayAddressComponent from "./displayAddressComponent"

import { GlobalStore } from "../../../store/GlobalStore";
import {  getTripFare , validateCsv, getDeiveryAddressFromCsv} from "../services/handlers";
import {  validateAddressBody } from "../services/validators";
import Papa from 'papaparse';
import moment from "moment";

import "../../../styles/style.css"

function BookingComponent (props) {
    const droppable = useRef(null);
    let validationRef = useRef()
    const [isOpen, setIsOpen] = useState(false);
    const [selectedAccordion, setSelectedAccordion] = useState("");
    let history = useHistory();
    const datetime = (init, offset) => {
        var today = new Date(init.getTime() + offset)
        let year = today.getFullYear()
        let month = today.getMonth()<10 ? '0'+(today.getMonth()+1):today.getMonth()+1
        let day = today.getDate()<10 ? '0'+(today.getDate()):today.getDate()
        let hour = today.getHours()<10 ? '0'+(today.getHours()):today.getHours()
        let minute = today.getMinutes()<10 ? '0'+(today.getMinutes()):today.getMinutes()
    
        return {year, month, day, hour, minute}
    }

    const tenMinutesAfter = datetime(new Date(), 10*60000)

    const minDate = tenMinutesAfter.year+'-'+tenMinutesAfter.month+'-'+tenMinutesAfter.day
    const minTime = tenMinutesAfter.hour+':'+tenMinutesAfter.minute

    // const listenerOut = useRef(null);
    const values = ['Enter Sender Address' , 'Enter Receiver Address', '1 +Add Stops', '2 +Add Stops', '3 +Add Stops', '4 +Add Stops', '5 +Add Stops'];
    const accordionGroup = useRef(null);
    const accordionGroupChange = (ev) => {
        // const nativeEl = listenerOut.current;
        // if (!nativeEl) {
        //   return;
        // }
    
        const selectedValue = ev.detail.value;
        setSelectedAccordion(ev.detail.value)
      };
    
      const closeAccordion = () => {
        
        const nativeEl = accordionGroup.current;
    
          nativeEl.value = undefined;
       
      };

    const [deliveryAddresses , setDeliveryAddress] = useState({
        pickUpLocation : {
            showEdit: true

        },
        dropOffLocation : {
            showEdit: false
        },
        additionalStops : [

        ],
        currency:'',
        tripFare:'',
        duration:'',
        priceId:'',
        errorMessage: '',
        validationPassed : true,
        goToPayment:false,
        calculateTripFare : true,
        rideStartTime: '',
    })


    const [places, setPlaces] = useState([])

    const {
        setDeliveryDetails ,
        getDeliveryDetails
    }= GlobalStore()


    const [date , setDate] = useState(minDate)
    const [time , setTime] = useState(minTime)

    

    useEffect(()=>{
        // const deliveryDetailsHistory = getDeliveryDetails()

        
        
        const deliveryDetailsHistory =  sessionStorage.getItem("deliveryAddresses") ? JSON.parse(sessionStorage.getItem("deliveryAddresses")) : {}
        
        if (Object.keys(deliveryDetailsHistory).length !== 0) {
            setDeliveryAddress(deliveryDetailsHistory)
        }
        setDate(minDate)
        setTime(minTime)

        

    },[])

    const [present] = useIonAlert();
    const [csvUploadError, setCsvUploadError] = useState({
        showError: false,
        errorMessage : ""
    })

    const checkIfMapsNeedtoBeDisplayed = () => {
        // (Object.keys(deliveryAddresses.pickUpLocation ).length !== 0
        // && Object.keys(deliveryAddresses.dropOffLocation ).length !== 0)  &&

        if (
            deliveryAddresses.pickUpLocation.latitude && deliveryAddresses.pickUpLocation.longitude && 
            deliveryAddresses.dropOffLocation.latitude
            && deliveryAddresses.dropOffLocation.longitude
        ) {return true}
        return false
    }

    const onFileDrag = (e) => {
        e.preventDefault();
        const div = droppable.current;
        div.classList.add("dragging");
    }

    const onFileLeave = (e) => {
        e.preventDefault();
        const div = droppable.current;
        div.classList.remove('dragging');
    }

    const onFileUpload = (e, label) => {
        try {
            const check = label === 'drop'
            if (check) { e.preventDefault() }
            Papa.parse(check ? e.dataTransfer.files[0]: e.target.files[0], {
                header: true,
                preview: 7,
                error: async function (){
                    throw Error('Invalid CSV file. Download the template for the correct csv file format')
                },
                complete: async function(results) {
                    var output = results;
                    var parsed = ([
                        ...output.data.map((item, index) => {
                            return {
                                postal:item['POSTCODE'],
                                name:item['CONTACT NAME'],
                                number:item['CONTACT NUMBER'],
                                notes:item['Delivery Notes'],
                                floor:item['FLOOR'],
                                unit:item['UNIT']
                            }
                        })
                    ])
                    
                    validateCsv(parsed)
                    let response = getDeiveryAddressFromCsv(parsed, deliveryAddresses, setDeliveryAddress)
                    if (response ){
                        setIsOpen(false)
                    }
                }
            })

        } catch (err) {
            setCsvUploadError({
                showError: true,
                errorMessage : `${err.message}`
            })
        }
        
    }
    return (
        <>
            <div className="content">
                <div className="accordion-wrapper">
                {
                    props.bookingType === 'scheduledDelivery' &&
                    <>
                        <IonCard className="sequel1-card-scheduler" class='ion-no-margin date-wrapper'>
                            <div className="sequel1-card-scheduler-row">
                            <IonGrid>
                            <IonRow>
                                <IonCol>
                                    <IonLabel className="sequel1-label-scheduler">Select Date</IonLabel>
                                    <div className="sequel1-col-scheduler" style={{marginRight:'13px'}} >
                                        <IonInput className="sequel1-input-scheduler" min={minDate} value={date}
                                            onIonInput={(e) => {setDate(e.target.value); setDeliveryAddress({...deliveryAddresses,rideStartTime:moment(`${e.target.value} ${time}`).unix() })}} type="date"/>
                                        <IonIcon className="sequel1-icon-scheduler" icon={calendarClearOutline}/>
                                    </div>
                                </IonCol>
                                <IonCol>
                                    <IonLabel className="sequel1-label-scheduler">Select Time</IonLabel>
                                    <div className="sequel1-col-scheduler">
                                        
                                        <IonInput className="sequel1-input-scheduler"  value={time}
                                            onIonInput={(e) => {setTime(e.target.value); setDeliveryAddress({...deliveryAddresses, rideStartTime:moment(`${date} ${e.target.value}`).unix()}); }} type="time"/>
                                        <IonIcon className="sequel1-icon-scheduler" icon={timeOutline}/>
                                    </div>
                                </IonCol>
                            </IonRow>
                            </IonGrid>
                           
                           
                                
                        </div>
                        </IonCard>
                    
                        
                    </>
                }
                
                <h4 ref={validationRef} >Enter Address</h4>
                <a className='import-address' onClick={() => setIsOpen(true)}>Bulk Upload</a>
                {
                    !deliveryAddresses.validationPassed && <div className="warning-msg" >
                        <span > <img src="../img/error.svg" /> { deliveryAddresses.errorMessage } </span>
                    </div>
                }
                    
                    <IonModal isOpen={isOpen}>
                        <IonContent className="ion-padding upload-csv">
                            <a className="close-icon"  name="close-outline" onClick={() => setIsOpen(false)}><img src="img/close.svg" /> </a>
                            <h2> Import Bulk Addresses</h2>
                            <div >
                            <label 
                            ref={droppable} 
                            onDrop={(e) => onFileUpload(e, 'drop')}
                            onDragEnter={(e) => onFileDrag(e)}
                            onDragOver={(e) => onFileDrag(e)}
                            onDragLeave={(e) => onFileLeave(e)}
                            >
                                <div className='drag' >
                                <img src='../img/upload.png' />
                                <p >Drag a CSV File here to autofill addresses</p>
                                <input onChange={(e) => onFileUpload(e, 'click')} type='file' accept='.csv' style={{display:"none"}}/>
                                </div>
                            </label>
                            
                            
                            
                            
                            </div>
                            <a  href="./csv/Sample.csv" >Download Template</a>
                        </IonContent>
                    </IonModal>
                    
                    <div className='search-wrapper'>
                        <DisplayAddressComponent deliveryAddresses={deliveryAddresses}  setDeliveryAdderss={setDeliveryAddress} validation={validateAddressBody} />
                    </div>
                </div>
                 {checkIfMapsNeedtoBeDisplayed() && <MapComponent deliveryAddresses={deliveryAddresses} setDeliveryAdderss={setDeliveryAddress} /> }
                { checkIfMapsNeedtoBeDisplayed() &&
                    <SummaryComponent deliveryAddresses={deliveryAddresses}  setDeliveryAdderss={setDeliveryAddress} /> 
                }
                
                <BottomNavComponent showBackButton={false} showNextButton={ !deliveryAddresses.goToPayment } displayLogic={()=>{ 

                       let v = validateDeliveryAddressBeforeSubmit(deliveryAddresses)
                       if(!v.validationPassed) {
                            let a = {...deliveryAddresses}
                            let b = {...a, ...v}
                            setDeliveryAddress(b)
                            validationRef.current.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
                            // window.scrollTo({ behavior: 'smooth', top: validationRef.current.offsetTop })
                       } else {
                            setDeliveryDetails({...deliveryAddresses, calculateTripFare:false, ...v})
                            sessionStorage.setItem("deliveryAddresses", JSON.stringify(deliveryAddresses));
                            history.push("/payment")
                       }
                }}/>
            </div>
        </>
    )
}


export default BookingComponent;